import { outOfBandThemeColors } from '@/theme/colors';
import { Button } from '@montugroup/design-system';
import { styled } from '@mui/material';

// Note: Consolidating tech-debt until new button variants are added to the theme

export const OutlinedButtonInverted = styled(Button)(({ theme }) => ({
  borderColor: outOfBandThemeColors.uMeds.merino,
  color: outOfBandThemeColors.uMeds.merino,
  '&:hover, &:active, &:focus': {
    //!important needed to override theming
    backgroundColor: theme.palette.common.white + '!important',
  },
}));

export const ContainedButtonInverted = styled(Button)(({ theme }) => ({
  //!important needed to override theming
  backgroundColor: outOfBandThemeColors.uMeds.merino + ' !important',
  color: theme.palette.primary.main,
  border: `1px solid ${theme.palette.primary.main} !important`,
  borderRadius: theme.spacing(1),
  '&:hover, &:active, &:focus': {
    //!important needed to override theming
    backgroundColor: theme.palette.primary.main + '!important',
    borderColor: outOfBandThemeColors.uMeds.merino + '!important',
    color: outOfBandThemeColors.uMeds.merino,
  },
}));
